<app-header [forceLightBackground]="true"></app-header>
<div class="org-admin-user-requests">
  <div class="org-admin-user-requests--layout">
    <app-org-admin-sidebar class="org-admin-user-requests--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-user-requests--content">
      <app-page-header></app-page-header>
      <div class="user-requests-container">
        <!-- Filter Panel -->
        <app-filter-panel
          [fields]="filterFields"
          [defaultExpanded]="false"
          (filterChange)="onFilterChange($event)"
          (clearFilters)="onClearFilters()"
        ></app-filter-panel>

        <!-- Custom Tabs -->
        <div class="custom-tabs">
          <div class="tabs-header">
            <button 
              *ngFor="let tab of tabs; let i = index"
              class="tab-button"
              [class.active]="activeTabIndex === i"
              (click)="onTabChange(i)"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tab-icon" [innerHTML]="tab.icon"></svg>
              <span>{{ tab.label }}</span>
            </button>
          </div>

          <div class="tabs-content">
            <!-- Join Requests Tab Content -->
            <div class="tab-panel" *ngIf="activeTabIndex === 0">
              <app-join-organisation-request
                [filters]="currentFilters"
              ></app-join-organisation-request>
            </div>

            <!-- Role Upgradation Tab Content -->
            <div class="tab-panel" *ngIf="activeTabIndex === 1">
              <app-role-upgradation-request
                [filters]="currentFilters"
              ></app-role-upgradation-request>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
